<!--
 * @Description: 
 * @Author: 长老
 * @Date: 2019-07-31 09:57:55
 * @LastEditTime: 2021-07-13 15:41:35
 * @LastEditors: chenzel
 -->
<template>
  <div class="commodity-group-view">
    <ul v-show="categoryList.length > 0" class="commodity-list ui-rows-wrap"
       v-infinite-scroll="$parent.loadItemListData" 
       infinite-scroll-immediate-check="true" 
       infinite-scroll-disabled="loading" 
       infinite-scroll-distance="10">
      <li class="border-bottom-1px border-right-1px gray-deep" v-for="(item,index) in categoryList" :key="index" @click="gotoDetailPage(item)">
        <!-- 已下架/抢光了-->
        <div class="item-pic-container">
          <div class="item-no-stock ui-rows ui-rows-center ui-rows-justify" v-if="item.disabled ==1 || item.stock <= 0">
              <!-- 已下架 -->
              <span v-show="item.disabled ==1" class="already-down no-stock-70px"></span>
              <!-- 抢光了 -->
              <span v-show="item.disabled ==0 && item.stock <= 0" class="loot-all no-stock-70px"></span>
          </div>
          <img :src="item.itemImgBig" onerror="this.src='//static.yunjiweidian.com/qnUpload/frontend/logo/icon-bitmap1.png'">
          <div class="tagNewAtmosphereSign" v-if="item.imageMark">
           <img :src="item.imageMark" alt="">
          </div>
        </div>
        <div class="item-content-container">
          <div class="item-title ui-nowrap-two">{{item.itemName}}</div>
          <div class="ui-rows-m">
            <markText :showAtmosphere="true" :markList="item.markArray"></markText>
            <!-- <markText ref="mark" :markList="item.markArray" :appCont="appCont"></markText> -->
          </div> 
        </div>
        <div class="ui-rows-m item-price">
          <em class="item-curr-price"><i class="price-right">&yen;</i>{{item.itemPrice}}</em>
          <em class="item-pre-price"><i class="price-right">&yen;</i>{{item.itemVipPrice}}</em>
        </div>
      </li>
    </ul>
    <ul class="last-page">
      <li v-show="isLastPage && categoryList.length > 0">
        <div class="item-bottom-tip">
          <ul class="ui-rows-m">
            <li class="ui-cols ui-cols-08 border-top-1px"></li>
            <li class="ui-cols ui-cols-2 item-bottom-title">没有更多了</li>
            <li class="ui-cols ui-cols-08 border-top-1px"></li>
          </ul>
        </div>
      </li>
      <li v-show="!isLastPage && categoryList.length > 0" class="item-page-infinite-loading"><mt-spinner type="fading-circle"></mt-spinner>加载中...</li>
    </ul>
    <div class="category-noResult" v-if="categoryList.length <= 0 && isShowNoResult">
      <div class="noResult">
        <div class="empty-search-pic"></div>
          暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import YunJi from '@/assets/js/YunJi'
import { InfiniteScroll,Spinner } from 'mint-ui';
import markText from '@/pages/commodity/components/Marking'

Vue.use(InfiniteScroll);
Vue.component(Spinner.name, Spinner);
export default {
  components: {
    markText
  },
  data() {
    return {
      markList: [],
    }
  },
  props: {
    categoryList:{
      type:Array,
      default(){
        return []
      }
    },
    shopId:{
      type: String,
      default(){
        return 0
      }
    },
    appCont:{
      type: String,
      default(){
        return 0
      }
    },
    isLastPage:{
      type: Boolean,
      default(){
        return false
      }
    },
    isShowNoResult:{
      type: Boolean,
      default(){
        return false
      }
    },
  },
  created() {
    
  },
  methods: {
    /**
     * 点击跳转商品详情
     */
    gotoDetailPage(itemObj){
      console.log(YunJi.isWxProgram(),"判断是否是小程序环境")
      if (YunJi.isWxProgram()|| parseInt(this.appCont,10) ===7) {
        //小程序环境下
        let itemStr =`?origin=1&shopId=${this.shopId}&itemId=${itemObj.itemId}`
        YunJi.useWxMini(()=>{
          wx.miniProgram.navigateTo({
            url:'../detail/detail'+itemStr
          })
        })
        return
      }else if(YunJi.isApp()){
        location.href = 'yunji://common/itemDetail?itemId='+itemObj.itemId;
        return
      }
      location.href = `//${globalConfig.linkBasePath}/yjbuyer/detail?itemId=${itemObj.itemId}&shopId=${this.shopId}&appCont=${this.appCont}`;
    },

  }
};
</script>

<style lang="less" scoped>
.commodity-group-view{
  flex: 1;
  overflow-y: auto;
  .commodity-list{
    li{
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 50%;
      min-height: 5rem;
      padding: 0.24rem 0;
      // margin: 0 auto;
      .item-pic-container{
        width: 3.26rem;
        height: 3.26rem;
        position: relative;
        top: 0;
        left: 0;
        img{
          width: 100%;
          height: 100%;
        }
        .tagNewAtmosphereSign{
          position: absolute;
          left:0.1rem;
          top:0.1rem;
          img{
            width:0.76rem;
            height:auto;
          }
        }
      }
      .item-content-container{
        width: 3.26rem;
        height: 1.3rem;
        .item-title{
          margin-top: 0.16rem;
          margin-bottom: 0.16rem;
          font-size: .24rem;
          color: #333;
          word-break: break-all;
        }
      }
      .item-price{
        width: 3.26rem;
        height: 0.4rem;
        line-height: 0.4rem;
        .item-curr-price{
          font-size: .28rem;
          color: #f10d3b;
          font-weight: 600;
        }
        .item-pre-price{
          font-size: 0.2rem;
          color: #9a9a9a;
          text-decoration: line-through;
          margin-left: 0.12rem;
        }
      }
    }
  }
  .last-page{
    width: 100%;
    // margin-top: 0.2rem;
    background-color: #F2F2F2;
    .item-bottom-tip{
      height: 0.8rem;
      width: 3.8rem;
      padding: 0;
      margin: 0 auto;
      background-color: #f2f2f2;
      .ui-rows-m{
        padding-top: 0.3rem;
        .item-bottom-title{
          font-size: 0.24rem;
          color: #9a9a9a;
          text-align: center;
        }
      }
    }
    .item-page-infinite-loading{
      height: 0.8rem;
      line-height: 0.8rem;
      text-align: center;
      color: #9a9a9a;
      background-color: #f2f2f2;
      span{
        display: inline-block;
        vertical-align: middle;
        margin-right: 0.2rem;
      }
    }
  }
  .category-noResult{
    display: flex;
    height: 100%;
    justify-content: center;
    font-size: .28rem; color: #9A9A9A;
    .noResult{
      padding-top: 2.2rem;
      text-align: center;
      .empty-search-pic{
        width: 1.5rem;
        height: 1.5rem;
        margin-bottom: 0.2rem;
        background-image: url('//static.yunjiweidian.com/qnUpload/frontend/logo/icon-nodata.png');
        background-repeat: no-repeat;
        background-size: 100%;
      }
    }
  }
  .item-cols-item { margin: 0 auto; width: 3.26rem; min-height: 5rem;}
  .item-pic-container { width: 3.26rem; height: 3.26rem; position: relative; top: 0; left: 0;}
  .item-pic-container > img { width: 100%; height: 100%; }
  .item-content-container { height: 1.3rem; }
  .item-title { margin-top: .16rem; margin-bottom: .16rem; font-size: .24rem; color: #333; word-break: break-all;}
  .item-no-stock {width: 3.26rem;height: 3.26rem; background: rgba(0,0,0,.4);position: absolute;top:0;left:0;z-index:1;color:#fff;font-size: .5rem;text-align: center}
  .label-android-more { line-height: .26rem;padding: .055rem .06rem 0 .06rem !important;}
}
</style>